<template>
  <div class="fontting">
    <div class="list" >
      <van-collapse v-model="activeNames" accordion @change="setactiveNames" class="font-size">
        <van-collapse-item :title="$t('append_field.fontSize')" name="5">
          <template #icon>
            <img src="/static/images/program/taFontSize.png" style="height: 25px;margin-right: 10px">
          </template>
          <div slot="right-icon"></div>
          <div style="width: 100%;height: 100%;display: flex;justify-content: center" slot="value">
            <van-stepper v-model="text.txList[0].taFontSize" min="0" integer max="150"></van-stepper>
          </div>
        </van-collapse-item>
        <!--  字幕大小 小70 中90 大120        -->
        <van-collapse-item :title="$t('append_field.fontColor')" name="1">
          <template #icon>
            <img src="/static/images/program/fontColor.png" style="height: 25px;margin-right: 10px">
          </template>
          <div slot="value" :style="{
            backgroundColor:text.txList[0].taColor,
            height:'100%',
            width:'40px'
          }"></div>
          <div slot="right-icon"></div>
          <pickerColor :isShow="showPickerColor" :bottom="bottomPickerColor" @callback='getPickerColor'
                       :initColor="text.txList[0].taColor"></pickerColor>
        </van-collapse-item>
        <van-collapse-item :title="$t('append_field.bgColor')" name="2">
          <template #icon>
            <img src="/static/images/program/bgColor.png" style="height: 25px;margin-right: 10px">
          </template>
          <div slot="value" :style="{
            backgroundColor:text.txList[0].taBgColor,
             height:'90%',
            width:'40px',
            border: '1px solid #808080FF',
          }"></div>
          <div slot="right-icon"></div>
          <pickerColor :isShow="showPickerColor" :bottom="bottomPickerColor" @callback='getPickerColor'
                       :initColor="text.txList[0].taBgColor"></pickerColor>
        </van-collapse-item>
        </van-collapse>
    </div>

  </div>

</template>

<script>
  import {mapState} from 'vuex'
  import pickerColor from "@/components/helang-pickerColor.vue";

  export default {
    components: {pickerColor},
    props: {
      text: {
        type: Object,
      },
    },
    data(){
      return{
        content: '',
        activeNames: ['1'],
        showPickerColor: false,
        bottomPickerColor: 0,
        taBgColor: '#00000000',
        taColor: "000000",
        fontColor: false,
        bjColor: false,

      }
    },
    mounted() {
      if(this.text && this.text.txList && this.text.txList[0]){
        this.content=this.text.txList[0].taContent
      }
      if(this.componentsList[this.controlIndex]&&this.componentsList[this.controlIndex].txList[0]){
        this.taColor = this.componentsList[this.controlIndex].txList[0].taColor
        this.taBgColor = this.componentsList[this.controlIndex].txList[0].taBgColor
      }

    },
    methods: {
      getPickerColor(color) {
        /* 隐藏弹窗 */
        this.showPickerColor = false
        this.activeNames = []
        /* 判断颜色值是否有效 */
        if (color) {
          if (this.fontColor) {
            this.taColor = color
            this.$store.state.componentsList[this.controlIndex].txList[0].taColor = color
          } else if (this.bjColor) {
            this.taBgColor = color
            this.$store.state.componentsList[this.controlIndex].txList[0].taBgColor = color
          }
          this.$set(this.componentsList, this.controlIndex, this.componentsList[
              this.controlIndex])
        }
      },
      setactiveNames(id) {
        this.fontColor = false
        this.bjColor = false
        if (id === '1') {
          this.fontColor = true
          this.showPickerColor = true
        } else if (id === '2') {
          this.bjColor = true
          this.showPickerColor = true
        }
      },

      fullscreen() {
        this.$emit('fullscreen')
      },
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .fontting {

    .font-size{
      .van-cell::after{
        border-bottom:none;
      }
    }
    .cell-content {
      display: flex;
      align-items: center;
    }

    .cell-icon {
      height: 20px;
      margin-right: 10px;
    }

    .cell-right {
      display: flex;
      align-items: center;
    }
    .van-cell__value {
      flex: none;

    }

    .btn {
      text-align: right;
      margin-top: 30px;
    }

    .van-col {
      text-align: center;
    }
    .van-row{
      padding: 10px 16px;
    }
    .activate {
      background: #006EFF;
      color: #fff;
    }

    .van-collapse-item__content {
      line-height: 40px !important;
      padding: 0;
      overflow: hidden;
    }
    .scrollSpeed{
      float: right !important;
    }
    .textarea {
      border: 1px solid #d8d8db;
      background: $uni-text-color-inverse;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 7px;
      width: 100%;
      height: 100px;
      margin-bottom: 20px;
    }
    .fontting-tab {
      height: 50px;
      position: fixed;
      white-space: nowrap;
      overflow-x: auto;
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 30;

      .control-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 50px;

        .control-item-title {
          font-size:  15px;
        }
      }
    }

  }

</style>
